import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SgSelectOption } from '../../../models';

@Component({
  selector: 'sg-dropdown-option-item',
  templateUrl: './sg-dropdown-option-item.component.html',
  styleUrls: ['./sg-dropdown-option-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgDropdownOptionItemComponent {
  @Input() option: SgSelectOption;
  @Input() isSelected = false;
  @Input() showCheckbox = false;
  @Input() showSelectedIcon = true;
}
